import { render, staticRenderFns } from "./screenSwitcher.vue?vue&type=template&id=537b760a"
import script from "./screenSwitcher.vue?vue&type=script&lang=js"
export * from "./screenSwitcher.vue?vue&type=script&lang=js"
import style0 from "./screenSwitcher.vue?vue&type=style&index=0&id=537b760a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537b760a')) {
      api.createRecord('537b760a', component.options)
    } else {
      api.reload('537b760a', component.options)
    }
    module.hot.accept("./screenSwitcher.vue?vue&type=template&id=537b760a", function () {
      api.rerender('537b760a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/screenSwitcher.vue"
export default component.exports